import React, { Fragment } from "react";
import { Col, Container, Row } from "reactstrap";
import MatTable from "./components/MatTable";
import Alert from "../../shared/components/Alert";
import AlertIcon from "mdi-react/InformationOutlineIcon";
import { connect } from "react-redux";
import { withOktaAuth } from "@okta/okta-react";
import { Redirect, withRouter } from "react-router-dom";
import TrialAlert from "../../shared/components/payment/TrialAlert";
import EnterpriseGate from "../../shared/components/payment/EnterpriseGate";
import { _hasPermission } from "../../shared/helpers/access";
import { isMobile } from "react-device-detect";

const BuildingSearch = ({ user }) => {
  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Building Search</h3>
          {!isMobile && (
            <h3 className="page-subhead subhead">
              Search All Buildings
            </h3>
          )}
        </Col>
      </Row>
      {_hasPermission(user, "pipeline-search") ? (
        <Fragment>
          <Row>
            <Col md={12} className={"mb-3"}>
              <TrialAlert />
            </Col>
          </Row>
          <Row>
            <Col md={12} className={"mb-3"}>
              <Alert
                color="success"
                className="alert--bordered"
                alertId="buildingSearch"
                icon
                iconItem={<AlertIcon />}
                minimizeText={`About Building Search`}
                hideOnStart
              >
                <p>
                  <span className="bold-text">{`About Building Search`}</span>
                  <div>{`Search across all building types including residential, commercial, industrial, and more.`}</div>
                </p>
              </Alert>
            </Col>
          </Row>
          <MatTable />
        </Fragment>
      ) : (
        <Row>
          <EnterpriseGate />
        </Row>
      )}
    </Container>
  );
};

export default connect((state) => ({
  user: state.user,
}))(withOktaAuth(withRouter(BuildingSearch)));
